<template>
  <v-container fluid class="claim-page">
    <!-- Alert -->
    <AAlertBanner :messages="alertError" hide-title />

    <!-- Confirmation Dialog -->
    <v-dialog v-model="claimSubmitDialog" max-width="460" content-class="claim-confirm-dialog">
      <div class="claim-confirm-card">
        <h3 class="claim-confirm-card__title">Claim Submitted to HRDC</h3>
        <p class="claim-confirm-card__message">Please confirm that you wish to Submit Claim to HRDC</p>
        <div class="claim-confirm-card__actions">
          <button
            class="claim-confirm-card__btn claim-confirm-card__btn--cancel"
            @click="claimSubmitDialog = false"
          >
            Cancel
          </button>
          <button
            class="claim-confirm-card__btn claim-confirm-card__btn--confirm"
            @click="modalClaimSubmit()"
          >
            Submit
          </button>
        </div>
      </div>
    </v-dialog>

    <!--BOC:[contents]-->
    <!-- Header -->
    <div class="claim-header">
      <div class="claim-header__top">

        <div v-if="!loadingDialog" class="claim-header__info">
          <h1 class="claim-header__title">
            {{ model.add.name }}
          </h1>
        </div>

        <div class="claim-header__actions">
          <span v-if="actionDownload">
            <v-menu
              offset-y
              :rounded="'lg'"
              transition="slide-y-transition"
              :max-height="'300'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: onTip, attrs: attrsTip }">
                    <button class="hero-action-btn hero-action-btn--purple" v-bind="{ ...attrs, ...attrsTip }" v-on="{ ...on, ...onTip }">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                      </svg>
                    </button>
                  </template>
                  <span>Download</span>
                </v-tooltip>
              </template>

              <v-card class="action-dropdown" elevation="8">
                <v-list dense class="py-2">
                  <v-list-item
                    v-for="(action, index) in actions"
                    :key="index"
                    link
                    class="action-dropdown__item"
                    @click="downloadAttachment(action)"
                  >
                    <v-list-item-title class="action-dropdown__text">{{ action }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </span>

          <span v-if="isHrdcAdminRoles && !btnDisabled">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="hero-action-btn hero-action-btn--green"
                  :disabled="apiSubmit.isLoading"
                  @click="claimSubmitDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="18">mdi-check-circle-outline</v-icon>
                </button>
              </template>
              <span>Submit</span>
            </v-tooltip>
          </span>
        </div>
      </div>
    </div>

    <!-- Claim Details Section -->
    <div class="section-card">
      <div class="section-header">
        <v-icon color="white" small>mdi-file-document-outline</v-icon>
        <span class="section-header__title">Claim Details</span>
      </div>
      <div class="section-body">
        <!-- Grant Approval No. -->
        <div class="form-row">
          <label class="form-label">Grant Approval No.</label>
          <div class="form-field">
            <div class="claim-copyable" @click="copyContent(formData.grantApprovalNo)">
              <span class="claim-copyable__text">{{ formData.grantApprovalNo || '-' }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="claim-copyable__icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9.75a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Claim ID -->
        <div class="form-row">
          <label class="form-label">Claim ID</label>
          <div class="form-field">
            <v-text-field
              dense
              filled
              v-model="formData.claimId"
              :error-messages="errorField.claimId"
            ></v-text-field>
          </div>
        </div>

        <!-- Claim Submit Date -->
        <div class="form-row">
          <label class="form-label">Claim Submit Date</label>
          <div class="form-field">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="rv-datepicker__trigger" v-bind="attrs" v-on="on">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-datepicker__icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                  </svg>
                  <span v-if="formData.claimSubmitDate" class="rv-datepicker__text">{{ formData.claimSubmitDate }}</span>
                  <span v-else class="rv-datepicker__placeholder">Select date (YYYY-MM-DD)</span>
                </div>
              </template>
              <v-date-picker
                v-model="formData.claimSubmitDate"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
    </div>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";

export default {
  mixins: [hrdcFunction],
  components: {},
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["params"],
  data: () => ({
    apiGetApplicationSingleDetail: new Api(),
    apiSubmit: new Api(),
    apiDownloadAttachment: new Api(),
    // apiGetCompanyDetails: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    formData: {
      applicationNo: null,
      claimId: null,
      grantApprovalNo: null,
      manualInvoiceToHrdc: null,
      claimSubmitDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
    },
    errorField: {
      applicationNo: null,
      claimId: null,
      claimSubmitDate: null,
    },
    loadingDialog: false,
    claimSubmitDialog: false,
    editMode: false,
    btnDisabled: false,
    companyName: null,
    applicationPrice: null,
    actions: [
      "Download All",
      "Download JD14",
      "Download T3",
      "Download Flyer",
      "Download HRDC Invoice",
    ],
    actionDownload: true,
  }),
  async created() {
    this.showLoadingDialog();
    this.formData.applicationNo = this.$route.query._ausk;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/claim_submit/create-claim`,
        method: "post",
      },
      apiGetApplicationSingleDetail: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-single-application`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
        },
      },
      apiDownloadAttachment: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/claim_submit/download-attachment`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
        },
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.stages = await this.hrdcData.allStages;
    const currentStageId =
      this.hrdcData.stageIndex[this.$store.state.hrdc.data.stageId];
    this.rolesAssignation(this.auth.roles);
    if (!this.isHrdcAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    this.checkFormAlreadyFilledGte(
      currentStageId,
      this.hrdcData.stageSlug.submittedClaimToHrdc
    );

    this.checkFormNotYetFilledLesser(
      currentStageId,
      this.hrdcData.stageSlug.manualInvoiceToHrdc
    );

    this.apiGetApplicationSingleDetail.setCallbackCompleted((response) => {
      try {
        const { status, data } = response;
        if (status) {
          // Append Grant Approval No.
          this.formData.grantApprovalNo = data.grantApprovalNo;

          // Append Manual/HRDC Invoice No..
          this.formData.manualInvoiceToHrdc = data.manualInvoiceToHrdc;

          // Append company based data.
          this.companyName = response.company.oldCompanyName;
          this.applicationPrice = data.totalPrice;

          // Check whether training end date is pass in order to submit claim.
          const today = moment().startOf("day");
          let trainingEndDate = null;
          const trainingEndDateObj = data.ApplicationLog.find(
            (item) =>
              item.stageId ==
              this.hrdcData.stagePriority.subscriptionDateScheduled
          );
          if (trainingEndDateObj) {
            trainingEndDate = moment(
              trainingEndDateObj.endDate,
              "YYYY-MM-DD HH:mm:ssZ"
            );
          }

          if (trainingEndDate) {
            if (
              trainingEndDate.isAfter(today) ||
              trainingEndDate.isSame(today)
            ) {
              this.alertError.push(
                "Please be informed that this application is not ready to submit claim."
              );
              this.btnDisabled = true;
            }
          }

          if (this.editMode) {
            const submittedClaimStageId =
              this.hrdcData.stagePriority.submittedClaimToHrdc;
            this.formData.claimId = data.claimId;
            let submittedClaim = data.ApplicationLog.find(
              (obj) => obj.stageId == submittedClaimStageId
            );

            if (submittedClaim) {
              this.formData.claimSubmitDate = moment(
                data.ApplicationLog.find(
                  (obj) => obj.stageId == submittedClaimStageId
                ).startDate
              ).format("YYYY-MM-DD");
            }
          }
        }

        this.hideLoadingDialog();
      } catch (err) {
        console.log(err);
      }
    });
    this.apiGetApplicationSingleDetail.fetch();
  },
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    modalClaimSubmit() {
      this.claimSubmitDialog = !this.claimSubmitDialog;
      this.submit();
    },
    copyContent(item) {
      const textarea = document.createElement("textarea");
      textarea.value = item;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");

      // Remove the temporary textarea
      document.body.removeChild(textarea);

      this.$store.dispatch("showMessage", {
        message: "Copied Successfully!",
        messageType: "info",
      });
    },
    async downloadAttachment(fileType) {
      this.showLoadingDialog();
      const filesDownload = [];

      // Categorise Flyer name.
      let pricing = this.getTaxpodBasePricing(Number(this.applicationPrice));
      let pricingList = this.staticTaxpodPricing;
      let defaultPricing = pricingList[0]; // Always take the first price as default.
      if (!pricingList.includes(pricing)) {
        pricing = defaultPricing;
      }

      let flyerPricing = this.staticTaxpodData;
      let flyerObj = flyerPricing.find((item) => item.price == pricing);

      switch (fileType) {
        case "Download All":
          filesDownload.push(
            {
              fileName: `${this.companyName}_JD14`,
              fileStage: this.hrdcData.stagePriority.clientRevertJd14Form,
              azureStorage: true,
            },
            {
              fileName: `${this.companyName}_T3`,
              fileStage: this.hrdcData.stagePriority.clientRevertT3Form,
              azureStorage: true,
            },
            {
              fileName: `${this.formData.manualInvoiceToHrdc}`,
              fileStage: this.hrdcData.stagePriority.manualInvoiceToHrdc,
              azureStorage: true,
            },
            {
              fileName: `taxPOD Masterclass Flyer ${flyerObj.flyer}`,
              fileStage: "null",
              azureStorage: false,
            }
          );

          break;
        case "Download JD14":
          filesDownload.push({
            fileName: `${this.companyName}_JD14`,
            fileStage: this.hrdcData.stagePriority.clientRevertJd14Form,
            azureStorage: true,
          });
          break;
        case "Download T3":
          filesDownload.push({
            fileName: `${this.companyName}_T3`,
            fileStage: this.hrdcData.stagePriority.clientRevertT3Form,
            azureStorage: true,
          });
          break;
        case "Download Flyer":
          filesDownload.push({
            fileName: `taxPOD Masterclass Flyer ${flyerObj.flyer}`,
            fileStage: "null",
            azureStorage: false,
          });
          break;
        case "Download HRDC Invoice":
          filesDownload.push({
            fileName: `${this.formData.manualInvoiceToHrdc}`,
            fileStage: this.hrdcData.stagePriority.manualInvoiceToHrdc,
            azureStorage: true,
          });
          break;
      }

      for (const file of filesDownload) {
        await this.$axios
          .get(this.apiDownloadAttachment.url, {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.auth.data.token}`,
            },
            params: {
              applicationUuid: this.$route.query._ausk,
              filesDownload: file.fileStage,
              azureStorage: file.azureStorage,
            },
          })
          .then((response) => {
            if (response.data.size > 10) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${file.fileName.trim()}.pdf`);
              document.body.appendChild(link);
              link.click();
            } else {
              this.$store.dispatch("showMessage", {
                message: "File is not ready yet",
                messageType: "info",
              });
            }
          })
          .catch((error) => {
            if ((error.response.status == 404) | true) {
              this.$store.dispatch("showMessage", {
                message:
                  "Failed to Preview/Download attachment, kindly contact administrator",
                messageType: "error",
                timeout: 2000,
              });
            }
          });
      }

      this.hideLoadingDialog();
    },
    redirectBack() {
      let route = "HrdcApplication";
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    async submit() {
      this.showLoadingDialog();
      let data = {
        applicationUuid: this.formData.applicationNo,
        claimId: this.formData.claimId,
        claimSubmitDate: this.formData.claimSubmitDate,
        referById: this.auth.uuid,
        editMode: this.editMode,
      };

      this.apiSubmit.setParams(data);
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          this.hideLoadingDialog();
          if (!response.status) {
            this.showErrorMessage(response);
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });
            this.$router.push({
              name: "HrdcApplication",
              query: {
                viewId: this.$store.state.hrdc.data.viewId,
              },
            });
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .claim-page {
  background-color: var(--app-page);
}

.dark-mode .claim-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--purple {
  background: var(--app-purple-bg);
}

.dark-mode .hero-action-btn--purple:hover {
  background: var(--app-purple-bg);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--blue:hover {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--green {
  background: var(--app-success-bg);
}

.dark-mode .hero-action-btn--green:hover {
  background: var(--app-success-bg);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .claim-copyable {
  background: var(--app-form-tile);
  border: 1px dashed var(--app-border);
}

.dark-mode .claim-copyable:hover {
  background: var(--app-accent-soft);
}

.dark-mode .claim-copyable__text {
  color: var(--app-text);
}

.dark-mode .claim-copyable__icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__trigger {
  border: 1px solid var(--app-field-border);
  background: var(--app-field);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .claim-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .claim-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .claim-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.claim-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  zoom: 1.1;
}

/* ============================================
   HEADER
   ============================================ */
.claim-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.claim-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px 16px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.claim-header__info {
  flex: 1;
  min-width: 0;
}

.claim-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

.claim-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 16px;
}

/* ============================================
   HERO ACTION BUTTONS
   ============================================ */
.hero-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.hero-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

.hero-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.hero-icon {
  width: 18px;
  height: 18px;
}

.hero-action-btn--purple {
  background: #f5f3ff;
  color: #8b5cf6;
}

.hero-action-btn--purple:hover {
  background: #ede9fe;
  color: #7c3aed;
}

.hero-action-btn--blue {
  background: #eff6ff;
  color: #3b82f6;
}

.hero-action-btn--blue:hover {
  background: #dbeafe;
  color: #2563eb;
}

.hero-action-btn--green {
  background: #dcfce7;
  color: #16a34a;
}

.hero-action-btn--green:hover {
  background: #d1fae5;
  color: #059669;
}

/* ============================================
   ACTION DROPDOWN
   ============================================ */
.action-dropdown {
  border-radius: 0 !important;
  overflow: hidden;
}

.action-dropdown__item {
  min-height: 40px !important;
  padding: 0 20px !important;
  transition: background-color 0.15s ease;
}

.action-dropdown__item:hover {
  background-color: #f0f4f8 !important;
}

.action-dropdown__text {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  color: #2d3239 !important;
}

.action-dropdown__item:hover .action-dropdown__text {
  color: #0ea5e9 !important;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-body {
  padding: 22px;
  background: #fff;
}

/* ============================================
   FORM ROWS & FIELDS
   ============================================ */
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.form-label {
  flex: 0 0 180px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3239;
  line-height: 1.6;
  padding-top: 10px;
}

.form-field {
  flex: 1;
  min-width: 0;
}

.form-field--inline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

/* ============================================
   COPY BUTTON
   ============================================ */
.claim-copyable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 8px 14px;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px dashed #e2e8f0;
  cursor: pointer;
  transition: all 0.15s ease;
}

.claim-copyable:hover {
  background: #e0f2fe;
  border-color: #0ea5e9;
}

.claim-copyable:active {
  background: #bae6fd;
}

.claim-copyable__text {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  font-family: 'Lato', sans-serif;
}

.claim-copyable__icon {
  width: 16px;
  height: 16px;
  color: #94a3b8;
  flex-shrink: 0;
  transition: color 0.15s;
}

.claim-copyable:hover .claim-copyable__icon {
  color: #0ea5e9;
}

/* ============================================
   DATEPICKER TRIGGER
   ============================================ */
.rv-datepicker__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
}

.rv-datepicker__trigger:hover {
  border-color: #94a3b8;
}

.rv-datepicker__icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  flex-shrink: 0;
}

.rv-datepicker__text {
  color: #1e293b;
  font-weight: 600;
}

.rv-datepicker__placeholder {
  color: #94a3b8;
}

/* ============================================
   VUETIFY INPUT OVERRIDES
   ============================================ */
.form-field >>> .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.form-field >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.form-field >>> .v-text-field__details {
  margin-bottom: 0 !important;
  padding-top: 2px !important;
  min-height: 0 !important;
}

.form-field >>> .v-messages {
  min-height: 0 !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}

.form-field >>> .v-input--is-focused .v-input__slot {
  border-color: #56bde8 !important;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12) !important;
}

.form-field >>> .v-input__slot::before,
.form-field >>> .v-input__slot::after {
  display: none !important;
}

/* Editable fields */
.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: #fff !important;
  border: 1.5px solid #d1d5db !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: #94a3b8 !important;
}

/* Disabled fields */
.form-field >>> .v-input--is-disabled .v-input__slot {
  background: #f1f5f9 !important;
  border: 1px dashed #e2e8f0 !important;
  cursor: not-allowed !important;
}

.form-field >>> .v-input--is-disabled input,
.form-field >>> .v-input--is-disabled textarea,
.form-field >>> .v-input--is-disabled .v-select__selection {
  color: #94a3b8 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot::before {
  border: none !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot::after {
  border: none !important;
}

.form-field >>> .v-label {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
}

.form-field >>> .v-text-field input,
.form-field >>> .v-select__selection,
.form-field >>> .v-text-field textarea {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

/* Error state */
.form-field >>> .v-input--has-state .v-input__slot {
  border-color: #f87171 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled).v-input--has-state > .v-input__control > .v-input__slot {
  border-color: #ef4444 !important;
}

.form-field >>> .v-messages__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  color: #ef4444;
}

/* ============================================
   CONFIRM DIALOG
   ============================================ */
.claim-confirm-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.claim-confirm-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.claim-confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
}

.claim-confirm-card__message {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0 0 24px;
  line-height: 1.5;
}

.claim-confirm-card__actions {
  display: flex;
  gap: 12px;
}

.claim-confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.claim-confirm-card__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.claim-confirm-card__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.claim-confirm-card__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.claim-confirm-card__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

/* ============================================
   VUETIFY OVERRIDES
   ============================================ */
.v-btn {
  opacity: 1 !important;
}

.v-messages__message {
  color: #ef4444;
}

/* ============================================
   MOBILE RESPONSIVE
   ============================================ */
@media (max-width: 599px) {
  .claim-page {
    padding: 12px 8px !important;
    zoom: 1;
  }

  .claim-header {
    border-radius: 14px;
    margin-bottom: 16px;
  }

  .claim-header__top {
    flex-wrap: wrap;
    padding: 16px 16px 12px;
  }

  .back-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    margin-right: 12px;
  }

  .claim-header__title {
    font-size: 1.05rem;
    white-space: normal;
  }

  .claim-header__actions {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
  }

  .hero-action-btn {
    width: 36px;
    height: 36px;
  }

  .section-card {
    border-radius: 14px;
    max-width: 100%;
    overflow: hidden;
  }

  .section-header {
    padding: 12px 16px;
  }

  .section-header__title {
    font-size: 0.65rem;
    letter-spacing: 1.5px;
  }

  .section-body {
    padding: 14px;
    overflow: hidden;
    word-break: break-word;
  }

  .form-row {
    flex-direction: column;
    gap: 2px;
    align-items: stretch;
  }

  .form-label {
    flex: none;
    width: 100%;
    font-size: 0.72rem;
    padding-top: 0;
    margin-bottom: 2px;
  }

  .form-field {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .form-field >>> .v-input {
    width: 100% !important;
  }

  .form-field >>> .v-input__control {
    width: 100% !important;
  }

  .form-field >>> .v-input__slot {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .form-field--inline {
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .claim-confirm-card {
    padding: 24px 20px 20px;
  }

  .claim-confirm-card__title {
    font-size: 1.05rem;
  }

  .claim-page {
    overflow-x: hidden;
  }
}

/* Tablet breakpoint */
@media (min-width: 600px) and (max-width: 959px) {
  .claim-page {
    zoom: 1;
  }

  .claim-header__top {
    padding: 20px 20px 14px;
  }

  .claim-header__title {
    font-size: 1.15rem;
  }

  .claim-header__actions {
    flex-wrap: wrap;
    gap: 4px;
  }

  .section-body {
    padding: 18px;
  }

  .form-label {
    flex: 0 0 160px;
  }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .claim-page {
  background-color: var(--app-page);
}

.dark-mode .claim-header {
  background: var(--app-card);
}

.dark-mode .claim-header__title {
  color: var(--app-text);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-card);
}

.dark-mode .section-header {
  background: linear-gradient(135deg, var(--app-accent), var(--app-accent));
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .form-label {
  color: var(--app-text-muted);
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot:hover {
  background: var(--app-field-hover) !important;
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--app-accent) !important;
  box-shadow: 0 0 0 3px var(--app-ring) !important;
}

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text);
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-field-placeholder);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-neutral-fg);
}

.dark-mode .hero-action-btn--purple {
  background: var(--app-purple-bg);
  color: var(--app-purple-fg);
}

.dark-mode .hero-action-btn--purple:hover {
  background: var(--app-purple-bg);
  color: var(--app-purple-fg);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
  color: var(--app-accent);
}

.dark-mode .hero-action-btn--blue:hover {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
}

.dark-mode .claim-copyable {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .claim-copyable:hover {
  background: var(--app-accent-soft);
  border-color: var(--app-accent);
}

.dark-mode .claim-copyable__text {
  color: var(--app-text-muted);
}

.dark-mode .claim-copyable:hover .claim-copyable__icon {
  color: var(--app-accent-strong);
}

.dark-mode .rv-datepicker__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .claim-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .claim-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .claim-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  color: var(--app-accent-strong);
  border-color: var(--app-form-tile-border);
}

.dark-mode .claim-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-accent-strong);
}

.dark-mode .claim-confirm-card__btn--confirm {
  background: var(--app-accent);
}

.dark-mode .claim-confirm-card__btn--confirm:hover {
  background: var(--app-accent);
}

/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text) !important;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-accent-soft) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top: 1px solid var(--app-border) !important;
}

/* >>> end auto-dark <<< */

/* ============================================
   VUETIFY DATE PICKER OVERRIDE (unscoped)
   ============================================ */
.v-picker {
  border-radius: 14px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  overflow: hidden;
  font-family: 'Lato', sans-serif !important;
}

.v-picker .v-picker__body {
  border: none !important;
}

/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */

.v-picker__body {
  background: #fff !important;
}

/* Month/year header */
.v-date-picker-header {
  padding: 12px 16px 8px !important;
  background: #fff !important;
}

.v-date-picker-header__value button {
  font-family: 'Lato', sans-serif !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  color: #1e293b !important;
}

.v-date-picker-header .v-btn {
  color: #64748b !important;
}

.v-date-picker-header .v-btn:hover {
  background: #f1f5f9 !important;
}

/* Weekday headers */
.v-date-picker-table thead th {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  padding: 8px 0 !important;
}

/* Day buttons */
.v-date-picker-table .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.v-date-picker-table .v-btn:hover {
  background: #f0f9ff !important;
}

.v-date-picker-table .v-btn--active {
  background: #0ea5e9 !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.v-date-picker-table .v-btn--active:hover {
  background: #0284c7 !important;
}

/* Today indicator */
.v-date-picker-table .v-btn--outlined {
  border-color: #0ea5e9 !important;
  color: #0ea5e9 !important;
}

/* Disabled days */
.v-date-picker-table .v-btn--disabled {
  color: #cbd5e1 !important;
}

/* Action buttons (Cancel/OK) */
.v-picker__actions {
  padding: 8px 16px 14px !important;
  background: #fff !important;
  border-top: 1px solid #f1f5f9 !important;
}

.v-picker__actions .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
}

/* Month picker (when clicking month/year) */
.v-date-picker-years li,
.v-date-picker-months .v-btn {
  font-family: 'Lato', sans-serif !important;
}

/* Dark mode */
.dark-mode .v-picker {
  border-color: var(--app-border) !important;
  box-shadow: 0 8px 30px var(--app-shadow-mid) !important;
}

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-neutral-fg) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table .v-btn--active {
  background: var(--app-accent) !important;
  color: var(--app-accent-fg) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top-color: var(--app-border) !important;
}
</style>
